import * as React from 'react';
import { SVGProps } from 'react';

const SvgVideoVisit = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      d="M29.7 18.5h3.7m-5-5 3.3-1.9m-3.2 11.9 3.2 1.8"
    />
    <path
      fill="currentColor"
      d="M18.2 20.7s.1 0 .2.1c1.5 1.1 2.5 2.9 2.6 5v8.5H8.6v-8.5c0-2.1 1-4 2.6-5.1.05-.05.125-.1.2-.15s.15-.1.2-.15c0-.1.1-.1.1-.1v1.6c-1.1.3-2 1.3-2 2.5V26h1.6v-1h-.6v-.6c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5v.6h-.4v1h1.6v-1.6c0-1.3-.9-2.3-2-2.5v-2.1h.1c.041 0 .1-.017.169-.037.097-.028.214-.063.331-.063-1.2-.6-2.1-1.8-2.1-3.2V15c0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4v1.6c0 1.5-.9 2.7-2.1 3.2.237 0 .412.063.623.138l.176.062c.05 0 .1.025.15.05s.1.05.15.05v3.5c-.3.2-.5.5-.5.9 0 .5.5 1 1 1s1-.5 1-1c0-.4-.2-.7-.5-.9v-2.9zm-7.4 8.4c0 .5.4 1 1 1 .5 0 1-.5 1-1s-.4-1-1-1-1 .5-1 1zm4 1c-.6 0-1-.5-1-1s.4-1 1-1 1 .5 1 1-.4 1-1 1zm1.9-1c0 .5.5 1 1 1 .6 0 1-.5 1-1s-.5-1-1-1-1 .5-1 1z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M8.5 4.3H21c1.4 0 2.5 1.1 2.5 2.5v25c0 1.4-1.1 2.5-2.5 2.5H8.5c-1.4 0-2.5-1.1-2.5-2.5v-25c0-1.4 1.1-2.5 2.5-2.5z"
    />
    <path fill="currentColor" d="M10.7 4h8v3.4h-8V4z" />
    <path fill={props.fill} d="M24.2 35.1v-4h-12l-4 4h16z" />
  </svg>
);

export default SvgVideoVisit;
